import { FormControl, Input } from "@chakra-ui/react";
import React from "react";

const FormInput = ({
  name,
  value,
  handleChange,
  type = "text",
  minLength = 3,
  maxLength = 20,
}) => {
  return (
    <FormControl width="100%" display="flex">
      <Input
        bg="gray.200"
        w="70%"
        m="auto"
        color="black"
        mt="30px"
        type={type}
        borderRadius="md"
        placeholder={`Enter ${name}`}
        minLength={minLength}
        maxLength={maxLength}
        name={name}
        value={value}
        onChange={handleChange}
      />
    </FormControl>
  );
};

export default FormInput;
